import { createImageGeneration } from './mocks';

const defaultState = () => ({
  form: {
    description: undefined,
  },
  generation: undefined,
});

const actions = {
  async createGeneration({ commit }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('setGeneration', createImageGeneration);
        resolve();
      }, 3000);
    });
  },
};

const mutations = {
  setForm(state, { scope, payload }) {
    state.form[scope] = payload;
  },
  setGeneration(state, payload) {
    state.generation = payload;
  },
  clear(state) {
    const clearState = defaultState();
    Object.keys(clearState).forEach((key) => {
      state[key] = clearState[key];
    });
  },
};

export default {
  namespaced: true,
  mutations,
  actions,
  state: defaultState,
};
